/**
 * t25 - Listing page JavaScript
 * Used only on collection and search pages.
 */

(function() {
  'use strict';

  function toggleFilterCheckboxes(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.target.closest('[data-action="toggle-filter-checkboxes"]');
    if (!button) return;

    const checkboxList = button.closest('.collection__filter-checkbox-list');
    if (!checkboxList) return;

    const allCheckboxes = checkboxList.querySelectorAll('.collection__filter-checkbox');
    const maxVisible = 6;
    const hiddenCheckboxes = Array.from(allCheckboxes).filter(function(checkbox) {
      return !checkbox.querySelector('button[data-action="toggle-filter-checkboxes"]');
    }).slice(maxVisible);

    if (hiddenCheckboxes.length === 0) return;

    const viewMoreText = button.getAttribute('data-view-more');
    const viewLessText = button.getAttribute('data-view-less');
    const currentText = button.textContent.trim();
    const isExpanded = currentText === viewLessText;

    if (isExpanded) {
      hiddenCheckboxes.forEach(function(checkbox) {
        checkbox.style.display = 'none';
        checkbox.classList.add('collection__filter-checkbox--hidden');
      });
      button.textContent = viewMoreText;
    } else {
      hiddenCheckboxes.forEach(function(checkbox) {
        checkbox.style.display = '';
        checkbox.classList.remove('collection__filter-checkbox--hidden');
      });
      button.textContent = viewLessText;
    }
  }

  function initHiddenCheckboxes(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const hiddenCheckboxes = scope.querySelectorAll('.collection__filter-checkbox--hidden');

    hiddenCheckboxes.forEach(function(checkbox) {
      checkbox.style.display = 'none';
    });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-action="toggle-filter-checkboxes"]')) {
      toggleFilterCheckboxes(event);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHiddenCheckboxes(document);
    });
  } else {
    initHiddenCheckboxes(document);
  }

  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          if (node.classList && node.classList.contains('collection__filter-checkbox-list')) {
            initHiddenCheckboxes(node);
            return;
          }

          if (node.querySelector && node.querySelector('.collection__filter-checkbox-list')) {
            initHiddenCheckboxes(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
